/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    name
    email
    phoneNumber
    storageTier
    storageUsed
    storageLimit
    friends {
      nextToken
      __typename
    }
    trips {
      nextToken
      __typename
    }
    stripeCustomerId
    subscriptionId
    subscriptionStatus
    subscriptionPeriodEnd
    appleSubscriptionId
    googleSubscriptionId
    appleReceiptData
    googlePurchaseToken
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const userByStripeCustomer = /* GraphQL */ `query UserByStripeCustomer(
  $stripeCustomerId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByStripeCustomer(
    stripeCustomerId: $stripeCustomerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByStripeCustomerQueryVariables,
  APITypes.UserByStripeCustomerQuery
>;
export const getStorageTierConfig = /* GraphQL */ `query GetStorageTierConfig($id: ID!) {
  getStorageTierConfig(id: $id) {
    id
    tier
    name
    storageBytes
    pricePerMonth
    features
    version
    isDefault
    createdAt
    updatedAt
    stripePriceId
    stripeProductId
    appleProductId
    googleProductId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStorageTierConfigQueryVariables,
  APITypes.GetStorageTierConfigQuery
>;
export const listStorageTierConfigs = /* GraphQL */ `query ListStorageTierConfigs(
  $filter: ModelStorageTierConfigFilterInput
  $limit: Int
  $nextToken: String
) {
  listStorageTierConfigs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tier
      name
      storageBytes
      pricePerMonth
      features
      version
      isDefault
      createdAt
      updatedAt
      stripePriceId
      stripeProductId
      appleProductId
      googleProductId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStorageTierConfigsQueryVariables,
  APITypes.ListStorageTierConfigsQuery
>;
export const storageTierConfigByTier = /* GraphQL */ `query StorageTierConfigByTier(
  $tier: StorageTier!
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTierConfigFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTierConfigByTier(
    tier: $tier
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tier
      name
      storageBytes
      pricePerMonth
      features
      version
      isDefault
      createdAt
      updatedAt
      stripePriceId
      stripeProductId
      appleProductId
      googleProductId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StorageTierConfigByTierQueryVariables,
  APITypes.StorageTierConfigByTierQuery
>;
export const getSubscriptionEvent = /* GraphQL */ `query GetSubscriptionEvent($id: ID!) {
  getSubscriptionEvent(id: $id) {
    id
    userId
    eventType
    platform
    subscriptionId
    productId
    previousTier
    newTier
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionEventQueryVariables,
  APITypes.GetSubscriptionEventQuery
>;
export const listSubscriptionEvents = /* GraphQL */ `query ListSubscriptionEvents(
  $filter: ModelSubscriptionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      eventType
      platform
      subscriptionId
      productId
      previousTier
      newTier
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionEventsQueryVariables,
  APITypes.ListSubscriptionEventsQuery
>;
export const subscriptionEventsByUserIdAndCreatedAt = /* GraphQL */ `query SubscriptionEventsByUserIdAndCreatedAt(
  $userId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionEventsByUserIdAndCreatedAt(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      eventType
      platform
      subscriptionId
      productId
      previousTier
      newTier
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubscriptionEventsByUserIdAndCreatedAtQueryVariables,
  APITypes.SubscriptionEventsByUserIdAndCreatedAtQuery
>;
export const getFriend = /* GraphQL */ `query GetFriend($id: ID!) {
  getFriend(id: $id) {
    id
    userId
    friendId
    friendName
    phoneNumber
    invited
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFriendQueryVariables, APITypes.GetFriendQuery>;
export const listFriends = /* GraphQL */ `query ListFriends(
  $filter: ModelFriendFilterInput
  $limit: Int
  $nextToken: String
) {
  listFriends(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      friendId
      friendName
      phoneNumber
      invited
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFriendsQueryVariables,
  APITypes.ListFriendsQuery
>;
export const friendsByUserId = /* GraphQL */ `query FriendsByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFriendFilterInput
  $limit: Int
  $nextToken: String
) {
  friendsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      friendId
      friendName
      phoneNumber
      invited
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FriendsByUserIdQueryVariables,
  APITypes.FriendsByUserIdQuery
>;
export const getTrip = /* GraphQL */ `query GetTrip($id: ID!) {
  getTrip(id: $id) {
    id
    tripName
    description
    startDate
    endDate
    createdBy
    storageUsed
    members {
      nextToken
      __typename
    }
    photos {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTripQueryVariables, APITypes.GetTripQuery>;
export const listTrips = /* GraphQL */ `query ListTrips(
  $filter: ModelTripFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrips(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTripsQueryVariables, APITypes.ListTripsQuery>;
export const tripsByCreatedBy = /* GraphQL */ `query TripsByCreatedBy(
  $createdBy: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTripFilterInput
  $limit: Int
  $nextToken: String
) {
  tripsByCreatedBy(
    createdBy: $createdBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TripsByCreatedByQueryVariables,
  APITypes.TripsByCreatedByQuery
>;
export const getTripMember = /* GraphQL */ `query GetTripMember($id: ID!) {
  getTripMember(id: $id) {
    id
    tripId
    userId
    role
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    user {
      id
      name
      email
      phoneNumber
      storageTier
      storageUsed
      storageLimit
      stripeCustomerId
      subscriptionId
      subscriptionStatus
      subscriptionPeriodEnd
      appleSubscriptionId
      googleSubscriptionId
      appleReceiptData
      googlePurchaseToken
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTripMemberQueryVariables,
  APITypes.GetTripMemberQuery
>;
export const listTripMembers = /* GraphQL */ `query ListTripMembers(
  $filter: ModelTripMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  listTripMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tripId
      userId
      role
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTripMembersQueryVariables,
  APITypes.ListTripMembersQuery
>;
export const tripMembersByTripId = /* GraphQL */ `query TripMembersByTripId(
  $tripId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTripMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  tripMembersByTripId(
    tripId: $tripId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tripId
      userId
      role
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TripMembersByTripIdQueryVariables,
  APITypes.TripMembersByTripIdQuery
>;
export const tripMembersByUserId = /* GraphQL */ `query TripMembersByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelTripMemberFilterInput
  $limit: Int
  $nextToken: String
) {
  tripMembersByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tripId
      userId
      role
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TripMembersByUserIdQueryVariables,
  APITypes.TripMembersByUserIdQuery
>;
export const getPhoto = /* GraphQL */ `query GetPhoto($id: ID!) {
  getPhoto(id: $id) {
    id
    tripId
    fileName
    s3Key
    uploadedBy
    status
    fileSize
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      storageUsed
      createdAt
      updatedAt
      __typename
    }
    contentType
    thumbnailS3Key
    thumbnailWidth
    thumbnailHeight
    thumbnailSize
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPhotoQueryVariables, APITypes.GetPhotoQuery>;
export const listPhotos = /* GraphQL */ `query ListPhotos(
  $filter: ModelPhotoFilterInput
  $limit: Int
  $nextToken: String
) {
  listPhotos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tripId
      fileName
      s3Key
      uploadedBy
      status
      fileSize
      contentType
      thumbnailS3Key
      thumbnailWidth
      thumbnailHeight
      thumbnailSize
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPhotosQueryVariables,
  APITypes.ListPhotosQuery
>;
export const photosByTripId = /* GraphQL */ `query PhotosByTripId(
  $tripId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPhotoFilterInput
  $limit: Int
  $nextToken: String
) {
  photosByTripId(
    tripId: $tripId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tripId
      fileName
      s3Key
      uploadedBy
      status
      fileSize
      contentType
      thumbnailS3Key
      thumbnailWidth
      thumbnailHeight
      thumbnailSize
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PhotosByTripIdQueryVariables,
  APITypes.PhotosByTripIdQuery
>;
export const getTripInvitation = /* GraphQL */ `query GetTripInvitation($id: ID!) {
  getTripInvitation(id: $id) {
    id
    tripId
    token
    role
    createdBy
    expiresAt
    usedBy
    usedAt
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTripInvitationQueryVariables,
  APITypes.GetTripInvitationQuery
>;
export const listTripInvitations = /* GraphQL */ `query ListTripInvitations(
  $filter: ModelTripInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  listTripInvitations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tripId
      token
      role
      createdBy
      expiresAt
      usedBy
      usedAt
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTripInvitationsQueryVariables,
  APITypes.ListTripInvitationsQuery
>;
export const tripInvitationsByTripIdAndExpiresAt = /* GraphQL */ `query TripInvitationsByTripIdAndExpiresAt(
  $tripId: ID!
  $expiresAt: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTripInvitationFilterInput
  $limit: Int
  $nextToken: String
) {
  tripInvitationsByTripIdAndExpiresAt(
    tripId: $tripId
    expiresAt: $expiresAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tripId
      token
      role
      createdBy
      expiresAt
      usedBy
      usedAt
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TripInvitationsByTripIdAndExpiresAtQueryVariables,
  APITypes.TripInvitationsByTripIdAndExpiresAtQuery
>;
export const getPhotoUploadURL = /* GraphQL */ `query GetPhotoUploadURL(
  $tripId: ID!
  $fileName: String!
  $contentType: String!
  $identityId: String!
  $fileSize: Float!
) {
  getPhotoUploadURL(
    tripId: $tripId
    fileName: $fileName
    contentType: $contentType
    identityId: $identityId
    fileSize: $fileSize
  ) {
    uploadURL
    photoId
    fileSize
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPhotoUploadURLQueryVariables,
  APITypes.GetPhotoUploadURLQuery
>;
export const getPhotoAccess = /* GraphQL */ `query GetPhotoAccess($photoId: ID!, $thumbnailOnly: Boolean) {
  getPhotoAccess(photoId: $photoId, thumbnailOnly: $thumbnailOnly) {
    bucket
    key
    region
    identityId
    thumbnailKey
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPhotoAccessQueryVariables,
  APITypes.GetPhotoAccessQuery
>;
export const generatePhotoDownload = /* GraphQL */ `query GeneratePhotoDownload(
  $photoIds: [ID!]!
  $tripId: ID!
  $zipDownload: Boolean
) {
  generatePhotoDownload(
    photoIds: $photoIds
    tripId: $tripId
    zipDownload: $zipDownload
  ) {
    downloadUrls {
      id
      url
      fileName
      __typename
    }
    zipUrl
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GeneratePhotoDownloadQueryVariables,
  APITypes.GeneratePhotoDownloadQuery
>;
export const getTripDetails = /* GraphQL */ `query GetTripDetails($tripId: ID!) {
  getTripDetails(tripId: $tripId) {
    id
    tripName
    description
    startDate
    endDate
    createdBy
    creatorName
    storageUsed
    members {
      id
      userId
      role
      userName
      createdAt
      updatedAt
      __typename
    }
    photos {
      id
      fileName
      s3Key
      uploadedBy
      uploaderName
      status
      fileSize
      contentType
      thumbnailS3Key
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    userRole
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTripDetailsQueryVariables,
  APITypes.GetTripDetailsQuery
>;
export const processInvitation = /* GraphQL */ `query ProcessInvitation($tripId: ID!, $token: String) {
  processInvitation(tripId: $tripId, token: $token) {
    trip {
      id
      tripName
      description
      startDate
      endDate
      createdBy
      creatorName
      storageUsed
      createdAt
      updatedAt
      userRole
      __typename
    }
    membership {
      id
      userId
      role
      userName
      createdAt
      updatedAt
      __typename
    }
    invitationProcessed
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProcessInvitationQueryVariables,
  APITypes.ProcessInvitationQuery
>;
export const getUserMemories = /* GraphQL */ `query GetUserMemories($limit: Int) {
  getUserMemories(limit: $limit) {
    items {
      id
      tripId
      tripName
      photoId
      fileName
      uploadDate
      thumbnailS3Key
      uploaderName
      captionText
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserMemoriesQueryVariables,
  APITypes.GetUserMemoriesQuery
>;
export const getStripeConfig = /* GraphQL */ `query GetStripeConfig {
  getStripeConfig {
    publishableKey
    allowedCards
    billingEnabled
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStripeConfigQueryVariables,
  APITypes.GetStripeConfigQuery
>;
export const getInAppProducts = /* GraphQL */ `query GetInAppProducts {
  getInAppProducts {
    products {
      id
      tier
      name
      pricePerMonth
      appleProductId
      googleProductId
      features
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInAppProductsQueryVariables,
  APITypes.GetInAppProductsQuery
>;
